<template>
	<div class="channel_detail">
		<div class="nav_cont">
			<div class="fh" @click="go_router"><i class="el-icon-arrow-left" style="margin-right: 12px;"></i>返回</div>
			<div class="fabu">渠道详情</div>
		</div>
		
		<el-row>
			<el-col :span="24">
				<div class="top_main">
					<div class="blue_d">
						基础信息
					</div>
					<el-col :span="12">
						<div class="top_title">
							<div class="top_t_i">渠道名称：{{info.name}}</div>
							<div>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址 ：{{info.province}}{{info.city}}{{info.county}}{{info.address}}</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="top_title">
							<div  class="top_t_i">联 &nbsp;系 人：{{info.linkman}}</div>
							<div>联系电话：{{info.phone}}</div>
						</div>
					</el-col>
				</div>
			</el-col>
		</el-row>
		
		
		<el-row>
			<el-col :span="24">
				<div class="top_main" style="margin-top: 16px;height: auto;">
					<div class="blue_d" style="display: inline-block;">
						销售数据
					</div>
					<div class="add_data" @click="showAddSaleData()">
						+销售数据
					</div>
					<div style="margin-top: 23px;">
						<span style="margin-right: 10px;margin-left: 16px;">销售时间</span>
						 <el-select v-model="date_time" @change='getlist()' placeholder="请选择" style="width: 148px;">
						    <el-option
						      v-for="item in date_times"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						 </el-select>
					</div>
					
					<div style="margin-top: 30px;">
						<el-table v-loading="loading" :data="list" style="width: 100%;">
							<el-table-column prop="bill_date" label="时间" align="center">
							</el-table-column>
							<el-table-column prop="order_num" label="销售笔数" align="center">
							</el-table-column>
							<el-table-column prop="amount" label="销售金额(元)" align="center" color>
							</el-table-column>
							<el-table-column prop="commission" label="分佣金额 (元)" align="center">
								<template slot-scope="scope">
									<div style="color: #000000;font-weight: 500;">
										{{scope.row.commission}}
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" width="300">
								<template slot="header" slot-scope="scope">
									<div>操作</div>
								</template>
								<template slot-scope="scope">
									<div>
										<el-button type="text" size="medium" @click="del(scope.row.id)">删除</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<!-- 分页器 -->
						<div class="block" style="padding: 40px;background: #ffffff;" v-if="list.length > 0">
							<el-pagination background align='center' @size-change="handleSizeChange"
								@current-change="handleCurrentChange" :current-page="currentPage" :page-size="50"
								layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		
		<dialog-bill :show="is_show_add" :channel_id="channel_id" @close="closeAddSaleData" @success="successAddSaleData"></dialog-bill>
	</div>
</template>

<script>
	
	import {
		basicInfo,
		ChannelDetail,
		delChannelData
	} from '@/api/channel';
	import dialogBill from '@/components/channel/add-bill.vue';
	
	export default {
		name: '',
		components: {
			dialogBill, // 销售数据导入
		},
		data() {
			return {
				info:[],
				list:[],
				date_times:[],
				date_time: '',
				currentPage: 0, // 当前页码
				total: 0, // 总条数
				loading: true,
				channel_id:0, // 渠道id
				is_show_add: false ,// 添加数据弹框显示状态
				oc_id:0, // 渠道关系id
			}
		},
		created() {
			let query = this.$route.query;
			var that = this;
			if (query.oc_id) {
				 that.oc_id = query.oc_id;
			}
			
			that.date_times = getlast5Month();
			that.date_time = that.date_times[0].value;
			
			that.getbasicInfo();
			that.getlist();
		},
		methods: {
			// 获取列表数据
			getlist() {
				var that = this;
				var currentPage = this.currentPage;
				
				ChannelDetail({
					page: currentPage,
					date_time: that.date_time,
					oc_id: that.oc_id
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.total = res.data.allcount;
						this.list = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			
			getbasicInfo(){
				var that = this;
				basicInfo({
					oc_id: that.oc_id
				}).then(res => {
					if (res.code == 0) {
						that.info = res.data;
						that.channel_id = res.data.channel_id;
					} else {
						that.$message.error(res.message);
					}
				})
			},
			
			// 返回上一页
			go_router(id) {
				this.$router.go(-1)
			},
			
			// 删除渠道
			del(id) {
				this.$confirm('确认删除该记录?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delChannelData({
						cd_id: id
					}).then(res => {
						if (res.code == 0) {
							this.$message.success(res.message);
							this.getlist();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
			
				});
			},
			
			// 销售数据导入 弹框
			showAddSaleData(){
				this.is_show_add = true;
				this.getlist();
			},
			
			// 关闭销售数据导入
			closeAddSaleData() {
				this.is_show_add = false
			},
			successAddSaleData(){
				this.getlist();
				this.is_show_add = false
			},
			// 每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
			},
			
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getlist();
			},
		},
		
	}
	
	
	function getlast5Month(){
	  let month_arr = {};
	  let d = new Date();  //这里是测试时设了一个时间 注意这里是 2021年4月1日  实际使用        
								   //的时候， 这里应该是 d = new Date();
	  let currentYear = d.getFullYear();
	  let currentMonth = d.getMonth();
	  let keyMonth = (d.getMonth() + 1) < 10? "0" + (d.getMonth() + 1) : (d.getMonth() + 1);  //js中的 getMonth是月份减1  在这里处理了
	  let key = currentYear + "-" + keyMonth;
	  
	  let tag = 0;   //这个tag是记录 跨年的次数的，后面的代码中 如果进入的跨年处理分支的话， 就把 
					 //tag加1
	  for(let i = 0;i<6;i++){   //前五个月， 所以这里循环了五次
		if(currentMonth - i < 0){        //这里是如果跨年的处理
		  tag++     //这个代码分支走了多少次，就加多少次
		  let newYear = currentYear-1;
		  keyMonth = 13 - tag;   // 为什么是13， 还不是因为 js 月份减一的问题
		  key = newYear + "-" + keyMonth; 
		month_arr[i] = {
					'value': key,
					'label': newYear + "/" + keyMonth,
		};
		  // month_arr[key] = newYear+"年"+ keyMonth+ "月";
		}else{            //这里是没有跨年的处理
		  keyMonth = (d.getMonth() + 1 - i) < 10? "0" + (d.getMonth() + 1 - i) : (d.getMonth() + 1 -i);
		  key = currentYear + "-" + keyMonth;
		 month_arr[i] = {
		 			'value': key,
		 			'label': currentYear + "/" + keyMonth,
		 };
		  // month_arr[key] = currentYear+"年"+ keyMonth+ "月";
		}
	  }
	  
	  return month_arr;
	}
	
</script>

<style scoped> 

	.channel_detail .nav_cont {
		width: 100%;
		height: 30px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		margin-bottom: 15px;
	}
	.channel_detail .fh {
		width: 80px;
		height: 23px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
		border-right: 1px solid #CCCCCC;
		margin-right: 21px;
		cursor: pointer;
	}
	.channel_detail .fabu {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}
	.top_main{
		height: 197px;
		background: #FFFFFF;
		border-radius: 4px;
		overflow: hidden;
	}
	.blue_d{
		width: 72px;
		height: 25px;
		margin-top: 23px;
		border-left: 3px #409EFF solid;
		padding-left: 20px;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}
	.top_title{
		margin-top: 36px;
		margin-left: 60px;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #666666;
	}
	.top_t_i{
		margin-bottom: 20px;
	}
	.add_data{
		width: 105px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		display: inline-block;
		margin-left: 20px;
	}

</style>
